export const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII"];

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

export const inr = (n) =>
  "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (d) => {
  if (!d) return "Date to be fixed";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const relTime = (iso) => {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return fmtDate(iso);
};

export const currentPct = (goal) => {
  const p = goal?.progress || {};
  for (let i = 8; i >= 1; i--) {
    const v = p[`m${i}`];
    if (v !== undefined && v !== null && v !== "") return Number(v);
  }
  return null;
};

const filled = (goal) =>
  ROMAN.map((_, i) => goal?.progress?.[`m${i + 1}`]).map((v) =>
    v === undefined || v === null || v === "" ? null : Number(v),
  );

/* Reporting streak: consecutive chapters reported, counting back from the last entry. */
export const reportStreak = (goal) => {
  const vals = filled(goal);
  const last = vals.reduce((acc, v, i) => (v !== null ? i : acc), -1);
  if (last < 0) return 0;
  let n = 0;
  for (let i = last; i >= 0; i--) {
    if (vals[i] === null) break;
    n += 1;
  }
  return n;
};

/* Chapters where progress moved forward. */
export const gainCount = (goal) => {
  const vals = filled(goal).filter((v) => v !== null);
  let n = 0;
  for (let i = 1; i < vals.length; i++) if (vals[i] > vals[i - 1]) n += 1;
  return n;
};

export const MILESTONES = [25, 50, 75, 100];

export const milestonesHit = (goal) => {
  const best = Math.max(0, ...filled(goal).filter((v) => v !== null));
  return MILESTONES.filter((m) => best >= m);
};

export const goalPoints = (goal) => {
  const pct = currentPct(goal) || 0;
  return (
    Math.round(pct) +
    reportStreak(goal) * 10 +
    gainCount(goal) * 5 +
    milestonesHit(goal).length * 15 +
    (goal.status === "Done" || pct === 100 ? 40 : 0)
  );
};

export const memberScore = (goals) => {
  const pcts = goals.map(currentPct).filter((v) => v !== null);
  return {
    points: goals.reduce((a, g) => a + goalPoints(g), 0),
    momentum: pcts.length ? Math.round(pcts.reduce((a, b) => a + b, 0) / pcts.length) : 0,
    streak: goals.length ? Math.max(...goals.map(reportStreak)) : 0,
    badges: goals.reduce((a, g) => a + milestonesHit(g).length, 0),
    completed: goals.filter((g) => g.status === "Done" || currentPct(g) === 100).length,
  };
};

export const TIERS = [
  { at: 600, name: "Machine" },
  { at: 400, name: "Momentum" },
  { at: 220, name: "Building" },
  { at: 0, name: "Setting out" },
];

export const tierFor = (points) => TIERS.find((t) => points >= t.at).name;

export const isOverdue = (c) =>
  c.status === "Open" && c.dueDate && new Date(c.dueDate) < new Date(new Date().toDateString());

export const statusColor = (s) => {
  if (["Kept", "On track", "Done", "Paid"].includes(s)) return "var(--green)";
  if (["Slipped", "At risk", "Overdue"].includes(s)) return "var(--rust)";
  return "var(--ink-mute)";
};

export const CHECKPOINTS = ["Baseline", ...ROMAN, "Year-End"];

export const MEETING_TYPES = [
  "Regular",
  "Online",
  "Retreat 1-night",
  "Retreat 2-night",
  "Offsite",
];
